import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

import { PDF_OUTPUT_MARGIN } from "../constants";
const {
  colors: { ui },
} = constants;

const { heading1Obj, textLObj } = typographyStyles;

export const pageContentContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  marginTop: "20px",
};

export const PDFContainerCss: CSSObject = {
  padding: `${PDF_OUTPUT_MARGIN}px`,
  width: "800px",
};

export const pdfLogoContainerCss: CSSObject = {
  marginBottom: "40px",
};

export const pageHeadingContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  gridGap: "2px",
  marginBottom: "20px",
};

export const pageTitleCss: CSSObject = {
  ...heading1Obj,
  margin: 0,
};

export const pageSubTitleCss: CSSObject = {
  ...textLObj,
  margin: 0,
};

export const updatedOnTextCss: CSSObject = {
  ...textLObj,
  lineHeight: "100%",
  marginTop: "20px",
  color: ui.green[700],
};
